<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
document.addEventListener('DOMContentLoaded', () => {
    const paymentButton = document.querySelector('#more-payment-options-link');
    if (paymentButton) {
        // Modifier le texte du bouton
        paymentButton.textContent = 'Acheter maintenant';

        // Ajouter une redirection vers la page de paiement
        paymentButton.addEventListener('click', (event) => {
            event.preventDefault(); // Empêche le comportement par défaut du lien
            window.location.href = '/checkout'; // Redirige vers la page de paiement
        });
    }
});
